import { coloredSeperatorItem } from "../../interfaces/coloredSeperator/ColoredSeperator.type";
import styles from "./ColoredSeperator.module.css";

export default function ColoredSeperator({
  items,
}: {
  items: coloredSeperatorItem[];
}) {
  const seperatorStyle = {
    background: items?.[0]?.backgroundColor,
    "--box-shadow-color": items?.[0]?.backgroundColor,
  } as React.CSSProperties;

  return (
    <div
      className={`${styles.invertedBorderRadius} ${styles?.[items?.[0]?.size]}`}
      style={seperatorStyle}
    >
      <span
        className={`${styles.topBefore} ${styles?.[items?.[0]?.size]}`}
      ></span>
      <span
        className={`${styles.topAfter} ${styles?.[items?.[0]?.size]}`}
      ></span>
    </div>
  );
}
